<template>
  <div>
    <el-dialog
      custom-class="loading-box"
      :visible="centerDialogVisible"
      center
      width="450px"
      :show-close="false"
    >
      <slot></slot>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click.native="onConfirmButton"
          >確定</el-button
        >
        <el-button @click.native="onCancelButton">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    titleCh: {
      type: String,
      default: "",
    },
    titleEn: {
      type: String,
      default: "",
    },
    centerDialogVisible: {
      type: Boolean,
      default: false,
    },
    isICon: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onCancelButton() {
      this.$emit("onCancelButton");
    },
    onConfirmButton() {
      this.$emit("confirmFunction");
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .loading-box {
    border-radius: 10px;
  }
}
.loading-icon {
  font-size: 55px;
  text-align: center;
}
.loading-text {
  font-size: 20px;
}
</style>
